import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectCartItems,
  selectCartTotal,
} from '../../redux/selectors/cartSelector';
import { removeItemFromCart } from '../../redux/slices/cartSlice';
import { setSelectedProduct } from '../../redux/slices/productSlice';
import { updatePrice } from '../../utils/helper';
import Button from '../Button';

const MiniCart = () => {
  const products = useSelector(selectCartItems); // selector to get products in cartItems
  const cartTotal = useSelector(selectCartTotal); // selector to get cart total
  const dispatch = useDispatch();

  // Dispatch the action the to get product details data
  const handleProductDetails = (product) => {
    dispatch(setSelectedProduct({ ...product, productId: product.id }));
  };

  // Dispatch the action to remove product from cart
  const handleRemove = (id, title) => {
    dispatch(removeItemFromCart({ id: id, title: title }));
  };

  return (
    <>
      {products.length === 0 ? (
        <div className="minicart text-center py-5">
          <h5 className="mb-5">Your Cart is Empty</h5>
          <p className="mb-40">
            Browse our collection and find something you love!
          </p>
          <Link className="it-btn-theme" to="/shop-sidebar">
            <Button btnText="Back To Shop" />
          </Link>
        </div>
      ) : (
        <div className="minicart">
          {products.map((product) => (
            <div
              key={product.id}
              className="cart-content-wrap d-flex align-items-center justify-content-between"
            >
              <div className="cart-img-info d-flex align-items-center">
                <div className="cart-thumb">
                  <Link
                    to={`/shop/${product.id}`}
                    onClick={() => handleProductDetails(product)}
                  >
                    <img src={product.thumbnail} alt="" />
                  </Link>
                </div>
                <div className="cart-content">
                  <h5 className="cart-title">
                    <Link
                      to={`/shop/${product.id}`}
                      onClick={() => handleProductDetails(product)}
                    >
                      {product.title}
                    </Link>
                  </h5>
                  <span>
                    ${Math.round(updatePrice(product)).toFixed(2)} x{' '}
                    {product.quantity}
                  </span>
                </div>
              </div>
              <div className="cart-del-icon">
                <span onClick={() => handleRemove(product.id, product.title)}>
                  <i className="fa-light fa-trash-can"></i>
                </span>
              </div>
            </div>
          ))}

          <div className="cart-total-price d-flex align-items-center justify-content-between">
            <span>Total:</span>
            <span>${Math.round(cartTotal).toFixed(2)}</span>
          </div>
          <div className="cart-btn">
            <Link
              className="it-btn-theme w-100 d-flex justify-content-center mb-10"
              to="/cart"
            >
              <Button btnText="Shopping Cart" />
            </Link>
            <Link
              className="it-btn-theme black-bg d-flex justify-content-center w-100"
              to="/checkout"
            >
              <Button btnText="Checkout" />
            </Link>
          </div>
        </div>
      )}
    </>
  );
};

export default MiniCart;
